import React from "react";
import { Button, type ButtonProps } from "@chakra-ui/react";

type Props = {
  isActive: boolean;
  children: string;
} & ButtonProps;

export function SidebarButton({ isActive, children, ...props }: Props) {
  return (
    <Button
      variant="unstyled"
      fontFamily="inherit"
      fontSize="sm"
      height="auto"
      transition="150ms all"
      color={isActive ? "grass" : undefined}
      textDecoration={isActive ? "underline" : undefined}
      textUnderlineOffset={3}
      _hover={{ color: "grass" }}
      {...props}
    >
      {children}
    </Button>
  );
}
